<div class="row row--primary">
  <div class="col-12 text-center mb-2 lottie-animation">
    <ng-lottie [options]="options" />
  </div>
  <div class="col-12 text-center mb-2">
    <h1 data-zid="multi-order-success-headline" class="mb-1">{{ 'trade.multi-order.success.headline' | transloco }}</h1>
    <p data-zid="multi-order-success-test">{{ 'trade.multi-order.success.text' | transloco }}</p>
  </div>
  <div class="col-12 mb-2 d-flex justify-content-center">
    <div class="button-container">
      <web-design-system-button data-zid="multi-order-success-primary" (click)="navigateToDepot()" size="small" [fullwidth]="true">
        {{ 'trade.multi-order.success.cta' | transloco | uppercase }}
      </web-design-system-button>
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center">
    <div class="button-container">
      <web-design-system-button
        data-zid="multi-order-success-secondary"
        (click)="navigateToOrders()"
        type="secondary"
        size="small"
        [fullwidth]="true"
      >
        {{ 'trade.multi-order.success.overview' | transloco | uppercase }}
      </web-design-system-button>
    </div>
  </div>
</div>
<trade-knowledge-and-experience [isins]="isins$ | async" class="d-block mt-4" />
